import { twMerge } from "tailwind-merge";

export interface LoaderProps {
  /**
   * Optional className for custom styling
   */
  className?: string;
  /**
   * Size of the loader in pixels
   * @default 24
   */
  size?: number;
  /**
   * Color of the loader
   * @default "text-action-brand"
   */
  color?: string;
}

/**
 * Loader
 *
 * Animated loading spinner component.
 * Displays a circular spinner with customizable size and color for loading states.
 */
export const Loader = ({ className, size = 24, color = "text-action-brand" }: LoaderProps) => {
  return (
    <div
      className={twMerge(
        "inline-block animate-spin rounded-full border-2 border-solid border-current border-r-transparent",
        color,
        className
      )}
      style={{
        width: size,
        height: size,
      }}
      role="status"
      aria-label="loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};
